/**
 * @fileoverview Initialize preview user data when not authenticated
 *
 * This component automatically initializes preview user and data when
 * the user is not signed in. It ensures preview data exists for demo mode.
 *
 * @module components/PreviewDataInitializer
 */

// Preview data initialization component
// Preview data is pre-initialized via direct mutation scripts
// This component is kept for potential future use

/**
 * PreviewDataInitializer Component
 *
 * Automatically initializes preview user and data when user is not signed in.
 * This ensures preview routes have data to display.
 *
 * Usage: Add this component once at the root of your app
 */
export function PreviewDataInitializer() {
  // Preview data is pre-initialized via direct mutation scripts
  // No automatic initialization on frontend
  return null
}

